import { createApp } from 'vue'
import App from './App.vue'
import router from './router';
import api from "@/api/http";

import './assets/styles/reset.css'; // 引入重置样式文件
const app = createApp(App);
// 定义全局变量
const globalConfig = {
  // wsURL: 'ws://gold.szzwei.cn/metalMarket/websocket'
  wsURL: 'wss://gold.szzwei.cn/metalMarket/websocket'

}
// const baseURL = 'https://gold.szzwei.cn';
//  const baseURL = '/api';

// 挂载到 app 全局属性（供 Vue 组件使用）
app.config.globalProperties.$globalConfig = globalConfig

// 同时挂载到 window（供 JS 文件使用）
window.$globalConfig = globalConfig
const urlParams = new URLSearchParams(window.location.search).get("v");
api.get('/metalMarket/sysTenantBoardConf/getByWebUrl/'+urlParams) // 假设后台接口为 /api/get-title
  .then(response => {
    const title = response.data.logoDesc || '中威软件'; // 如果没有标题，使用默认标题
    document.title = title;
  })
  .catch(() => {
    document.title = '中威软件'; // 请求失败时使用默认标题
  });
app.use(router);
app.mount('#app');
